import { useState } from "react";
import { Flex } from "../shared";
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import styled from "@emotion/styled";

const Controller = styled.button({
  color: "#DEE2F4",
  border: "2px solid #DEE2F4",
  fontSize: "2.5rem",
  outline: "none",
  width: "3rem",
  height: "3rem",
  borderRadius: "1rem",
  backgroundColor: "transparent",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontWeight: "bold",
  cursor: "pointer",
  userSelect: "none",

  "&:disabled": {
    opacity: "0.6",
    pointerEvents: "none",
  },
});

const Number = ({ label, max = 0, min = 0, step = 1, onChange }) => {
  const [value, setValue] = useState(min);

  return (
    <Flex
      css={{ justifyContent: "space-between", margin: "2rem 0", width: "100%" }}
    >
      <label css={{ fontSize: "2.5rem" }}>{label}</label>
      <Flex css={{ alignItems: "center" }}>
        <Controller
          disabled={value === min}
          onClick={() => {
            const tmp = value - 1 < min ? value : value - 1;
            setValue(tmp);
            onChange(tmp);
          }}
        >
          <div
            css={{ width: "8px", height: "2px", backgroundColor: "#DEE2F4" }}
          ></div>
        </Controller>
        <span css={{ fontSize: "2.5rem", margin: "0 2rem" }}>{value}</span>
        <Controller
          disabled={value === max}
          onClick={() => {
            const tmp = value + 1 > max ? value : value + 1;
            setValue(tmp);
            onChange(tmp);
          }}
        >
          +
        </Controller>
      </Flex>
    </Flex>
  );
};

export default Number;
